import { render } from "./RedZones.vue?vue&type=template&id=12d022d8"
import script from "./RedZones.vue?vue&type=script&lang=js"
export * from "./RedZones.vue?vue&type=script&lang=js"

import "./RedZones.vue?vue&type=style&index=0&id=12d022d8&lang=scss"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__